<template>
  <div class="space-y-1 mt-4">
    <label v-if="label" id="listbox-label" class="block text-sm font-medium text-gray-700 mb-1 font-bold">
      {{ label }}
    </label>
    <Select :model-value="initialValue" @update:model-value="emit('selected-option', $event)">
      <SelectTrigger class="border border-gray-300 rounded-md"
        ><SelectValue :placeholder="'Select ' + label"
      /></SelectTrigger>
      <SelectContent>
        <SelectItem v-for="option in options" :key="option" :value="option">
          {{ option }}
        </SelectItem>
      </SelectContent>
    </Select>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const { label, initialValue, options } = defineProps({
  label: String,
  initialValue: String,
  options: Array,
});

onMounted(() => {
  if (initialValue) {
    emit('selected-option', initialValue);
  }
});

const emit = defineEmits(['selected-option']);
</script>
